import { Alert } from "@mui/material";
import React, { useMemo } from "react";
import { FormattedMessage } from "react-intl";

function DisplayMirrorAlert({ display }) {
  const toggleAlert = useMemo(
    () => display?.children?.some((d) => d?.type === "MIRROR"),
    [display]
  );

  return (
    <>
      {toggleAlert && (
        <Alert sx={{ mt: 2 }} severity="warning">
          <FormattedMessage id="displaysScene.mirrorAlert" />
        </Alert>
      )}
    </>
  );
}

export default DisplayMirrorAlert;
